import { html } from "lit-html"

export const LocationInfo = (
  { location, link, remote, canceled, showMissing = false },
  expanded = false
) => {
  const isInPerson = location
  const isRemote = remote

  if (!location && !remote) {
    if (showMissing) {
      return html`<div class="mr-6">
        <i class="fas fa-location-dot mr-2 w-7 text-gray-450"></i>
        <span class="text-gray-icon"> No location detected </span>
      </div>`
    }
    return ``
  }

  if (!expanded) {
    return html`<div class="mr-6">
      <i
        class="fas fa-location-dot mr-2 w-7 ${canceled
          ? `text-gray-icon`
          : `text-gray-450`}"
      ></i>
      <span class="${canceled ? `line-through` : ``}">
        ${isInPerson ? "In-person" : ""} ${isInPerson && isRemote ? " & " : ""}
        ${isRemote ? "Remote" : ""}
      </span>
    </div>`
  }

  return html`
    ${isInPerson
      ? html`
          <div class="mr-6">
            <i
              class="fas fa-location-dot mr-2 w-7  ${canceled
                ? `text-gray-icon`
                : `text-gray-450`}"
            ></i>
            <span class="${canceled ? `text-gray-icon line-through` : ``}">
              In-person:
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=${window.encodeURIComponent(
                  location.display
                )}"
                target="_blank"
                class="inline-block"
              >
                ${location.display}
              </a>
            </span>
          </div>
        `
      : ``}
    ${isRemote
      ? html`
          <div class="mr-6">
            <i
              class="fas fa-location-dot mr-2 w-7  ${canceled
                ? `text-gray-icon`
                : `text-gray-450`}"
            ></i>
            <span class="${canceled ? `text-gray-icon line-through` : ``}">
              ${link
                ? html`Remote:
                    <a href="${link}" class="inline-block">${link}</a>`
                : html`Remote`}
            </span>
          </div>
        `
      : ``}
  `
}
